(function ManagerHotelMetadataOverrideForm($, HE)
{
	"use strict";

	var form = {
		name: 'HotelMetadataOverride',
	};

	$(document).ready(function documentReady()
	{
		HE.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		var $providers = $('#hotelmetadataoverride-metadata_provider_id'),
		    $clients   = $('#hotelmetadataoverride-client_id'),
		    $images    = $('#images > .row'),
		    giata_id   = $form.data('giata-id');

		HE.Typeahead(
			$('#hotelmetadataoverride-hotel_name'),
			'/Searches/hotel',
			function select(item, $self, typeahead) {
				giata_id = item.giata_id;
				typeahead.setHiddenValue(item.id);
				refreshMetadata();
			}
		);

		$providers.on('change', function changedProvider() {
			if (giata_id) {
				refreshMetadata();
			}
		});

		$clients.on('change', function changedClient() {
			HE.Ajax.get('/Clients/getEnabledProvidersForClient/' + this.value)
			.then(function populateEnabledProvidersForClient(data)
			{
				var opts = [];
				$providers.empty();

				Object.values(data).forEach(function _populateProviderIds(provider) {
					opts.push('<option value="' + provider.id + '">' + provider.name + '</option>');
				});

				$providers.append(opts);
				$providers.trigger('change');
			});
		});


		// if editing an existing override, get metadata immediately
		if ($providers.val() && giata_id) {
			$providers.trigger('change');
		}
		else {
			$clients.trigger('change');
		}


		function refreshMetadata()
		{
			var provider_id = $providers.val(),
			    images      = [],
			    key;

			$images.empty();

			HE.Ajax.get('/Hotels/getMetadataForGiata/'+giata_id+'/'+provider_id)
			.then(function gotMetadata(metadata) {
				for (key in metadata) {
					if ({}.hasOwnProperty.call(metadata, key)) {
						if (key === 'images') {
							metadata[key].forEach(function addImage(image) {
								images.push('<div class="col-3 py-1"><img src="'+image.thumbnail_url+'" class="img-thumbnail"></div>');
							});
						}
						else {
							$('.metadata-preview [data-key="'+key+'"]').text(metadata[key]);
						}
					}
				}

				$images.append(images);
			});
		}
	};

}(jQuery, window.HE || {}));